/**
 * Converte itens do grid do editor de layout para o formato de linha da API EDI.
 * @param {Array} items - Linhas do estado do EdiLayoutEditor
 * @returns {Array} Linhas no formato esperado por POST/PUT /edi/layouts
 */
export function mapEdiLayoutLinhasToApi(items) {
  return items.map((item, index) => ({
    registroId: item.registro,
    descricao: item.nome,
    observacao: item.observacao || null,
    posicaoInicial: Number(item.inicio) || 1,
    posicaoFinal: Number(item.inicio) + Number(item.tamanho) - 1,
    tamanho: Number(item.tamanho) || 1,
    tipoDado: item.alinhamento?.value || item.alinhamento,
    casasDecimais: item.casasDecimais !== '' && item.casasDecimais != null
      ? Number(item.casasDecimais)
      : null,
    mandatorio: Boolean(item.obrigatorio),
    valorFixo: item.valorPadrao || null,
    campoSistemaId: item.campoSistema?.value > 0 ? item.campoSistema.value : null,
    campoCatalogoId: item.campoCatalogoId ?? null,
    numeroCampo: index + 1,
  }));
}

export function sanitizeEdiLayoutCreatePayload(payload) {
  return {
    tenant: payload.tenant,
    tipoLayout: payload.tipoLayout || 'DOCCOB',
    nome: payload.nome,
    descricao: payload.descricao,
    linhas: payload.linhas,
  };
}

export function sanitizeEdiLayoutUpdatePayload(payload) {
  return {
    nome: payload.nome,
    descricao: payload.descricao,
    linhas: payload.linhas,
  };
}

/**
 * Monta o body de criação ou atualização de layout a partir do estado do editor.
 * @param {Object} params
 * @param {string} params.tenant
 * @param {string} params.nome
 * @param {string} [params.descricao]
 * @param {string} [params.tipoLayout]
 * @param {Array} params.linhas - Itens do grid (antes do mapeamento)
 * @param {boolean} params.isUpdate
 * @returns {Object} Payload para Api.createEdiLayout ou Api.updateEdiLayout
 */
export function buildEdiLayoutPayload({
  tenant, nome, descricao, tipoLayout, linhas, isUpdate,
}) {
  const linhasApi = mapEdiLayoutLinhasToApi(linhas);
  if (isUpdate) {
    return sanitizeEdiLayoutUpdatePayload({ nome, descricao, linhas: linhasApi });
  }
  return sanitizeEdiLayoutCreatePayload({
    tenant,
    tipoLayout: tipoLayout || 'DOCCOB',
    nome,
    descricao,
    linhas: linhasApi,
  });
}
